import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import styled from "styled-components";
import { Formik, Form } from "formik";
import { FormRow, FormRowMessage, FormTextbox, BlockButton } from "fiver-react-ui-components";
import schemaWithdraw from "./schemaWithdraw";
const StyledWrapper = styled.div``;

const WalletButtonsWithdraw = ({
  translations,
  currencySymbol,
  getWallet,
  onError,
  balance,
  setTransactionsUpdated
}) => {
  const [serverError, setServerError] = useState();

  const validate = values => {
    const errors = {};

    if (values.amount * 100 > balance) {
      errors.balance = `${translations.requestedAmount} ${translations.tooHighError}`;
    } else if (values.amount < 5) {
      errors.amount = `${translations.errorWithdraw.replace("$1", currencySymbol)}`;
    }

    return errors;
  };

  const onSubmit = async (values, {
    setSubmitting
  }) => {
    //setTransactionsUpdated(true);
    setServerError(undefined);
    let withdrawRes;

    try {
      withdrawRes = await axios.post(`/wallet/withdraw-request`, {
        password: values.password,
        amount: +(values.amount * 100).toFixed(2)
      });
      setSubmitting(false);
      setServerError(undefined);
      setTransactionsUpdated(true);
      getWallet();
      toast.success(translations.withdrawSuccess);
      window.xtremepush("tag", "Wallet.Withdraw", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE,
        amount: values.amount
      }));
    } catch ({
      response
    }) {
      if (response?.code === 401) {
        onError(response);
      }

      if (response?.data?.errors) {
        if (response?.data?.errors?.amount) {
          setServerError(`${translations.errorWithdraw.replace("$1", currencySymbol)}`);
        } else if (response?.data?.errors?.password) {
          setServerError(` ${translations.password} ${translations.invalid}`);
        }
      } else if (response?.data?.message === "This user has no payment source") {
        setServerError(translations.withdrawErrorNoCardAdded);
      } else if (response?.data?.message) {
        setServerError(response.data.message);
      } else {
        onError(response);
      }
    }
  };

  return /*#__PURE__*/React.createElement(Formik, {
    validationSchema: schemaWithdraw(translations),
    onSubmit: onSubmit,
    initialValues: {
      amount: "",
      password: ""
    },
    validate: validate
  }, ({
    isSubmitting,
    isValid,
    values,
    errors,
    dirty,
    handleChange
  }) => /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    isError: errors.amount || errors.balance,
    onChange: e => {
      if (serverError) {
        setServerError(undefined);
      }

      handleChange(e);
    },
    value: values.amount,
    name: "amount",
    type: "tel",
    prefix: currencySymbol,
    placeholder: translations.amount
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: errors.amount || errors.balance
  }, errors.amount, errors.balance), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    isError: !errors.amount && errors.password,
    onChange: e => {
      if (serverError) {
        setServerError(undefined);
      }

      handleChange(e);
    },
    value: values.password,
    name: "password",
    type: "password",
    placeholder: translations.password
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: !errors.amount && errors.password || serverError && isValid
  }, errors.password, serverError), /*#__PURE__*/React.createElement(BlockButton, {
    noDisabledStyles: true,
    disabled: !isValid || isSubmitting || !dirty,
    errorMessage: serverError,
    isLoading: isSubmitting,
    size: "sm",
    type: "submit"
  }, translations.withdraw)));
};

export default WalletButtonsWithdraw;